import { useEffect, useState, useRef, useMemo } from "react"
import { Row, Col, Carousel, message } from 'antd';
import { useCanvas } from './../components/canvas'
import { GetMoreWorkAxios, GetAssistList, GetAssistantCollection } from './ajax'
import { TeachingGroupPh } from './teachinggroupph'
import LazyLoad from 'react-lazyload';
import { BottomIfor } from './bottom/bottominfo';
import { ButtonforPh } from './bottom/buttomforph';
import { MoreWorksPc } from './homepage';
import { Floatingpc } from "../components/floatingpc";
import { Floatingph } from "../components/floatingph";

function TeachingGroup(props) {
  const [change, setChange] = useState([])
  const [atlist, setAtList] = useState([])
  const [atcolist, setAtColist] = useState([])
  const [shows, setShow] = useState(false);
  const [showmp, setShowmp] = useState(false);
  const [text, setText] = useState("一键复制QQ号");
  const showWindow = (a) => {
    setShow(a);
    setText("一键复制QQ号");
  };
  const showFloating = (e) => {
    setShowmp(true);
    e.nativeEvent.stopImmediatePropagation();
  };
  const hideFloating = (e) => {
    setShowmp(false);
    setText("一键复制QQ号");
  };
  useEffect(() => {
    document.addEventListener("touchstart", hideFloating);
  }, []);

  const reload = async () => {
    let [res, res2, res3] = await Promise.all([GetMoreWorkAxios(), GetAssistList(), GetAssistantCollection()])
    if (res.code !== 0 && res2.code !== 0 && res3.code !== 0) {
      message.error(res.message || res2.message || res3.message)
      return
    }
    else {
      setChange(res.data)
      setAtList(res2.data.filter(i => i.status === 1).sort((a, b) => b.sort - a.sort))
      setAtColist(res3.data)
    }
  }
  useEffect(() => {
    reload()
  }, [])
  return (
    <Row>
      <Col xs={0} sm={0} md={0} lg={24} xl={24}>
        <Floatingpc show={shows} showWindow={showWindow} text={text} setText={setText} />
        <TeachingGroupPc change={change} setChange={setChange} atlist={atlist} atcolist={atcolist} {...props} />
        <BottomIfor />
      </Col>
      <Col xs={24} sm={24} md={24} lg={0} xl={0}>
        <Floatingph showmp={showmp} showFloating={showFloating} text={text} setText={setText} />
        <TeachingGroupPh change={change} setChange={setChange} atlist={atlist} atcolist={atcolist}  {...props} />
        <ButtonforPh />
      </Col>
    </Row>
  )
}

function TeachingGroupPc(props) {
  let { change, setChange, atlist, atcolist } = props
  const [showmore, setShowMore] = useState(0)
  const collectbox = useRef()
  const [currenturl, setCurrentUrl] = useState()
  let setCanvas = useCanvas(useMemo(() => <CollectionBigImg atcolist={atcolist} currenturl={currenturl} />, [currenturl, atcolist]))

  useEffect(() => {

    let domheight = document.querySelector('.assistgroup-avator')
    if (!domheight) return
    let heightbox = window.getComputedStyle(domheight, null).height.replace('px', '') * 1
    if (heightbox <= 300 || isNaN(heightbox)) {
      setShowMore(0)
    }
    else {
      setShowMore(2)
    }

  }, [atlist])
  const divnum = Math.ceil(atcolist.length / 20)

  let arr = new Array(divnum).fill('').map((_, index) => {
    return atcolist.sort((a, b) => b.sort - a.sort).slice(index * 20, (index + 1) * 20)
  })
  let settings = {
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    slidesToShow: 1,
    dots: true,
  }

  const prev = () => {
    collectbox && collectbox.current.prev()

  }
  const next = () => {
    collectbox && collectbox.current.next()
  }
  return (
    <div className="assistgroup-box">
      <div className="krenz-introduce">
        <div className="middle-center">
          <div className="krenz-large-icon"></div>
          <div className="krenz-intro-text4">
            <div className="social-media">
              <div className="en-social-media"><span>KRENZ'S SOCIAL MEDIA</span></div>
              <div className="cn-social-media"><span>KRENZ的社交媒体</span></div>
            </div>
            <div className="social-icon">
              <a href="https://www.cctalk.com/m/group/82776894" rel="noreferrer" target="_blank"><div className="social-icon-cc"></div></a>
              <a href="https://space.bilibili.com/181578039" rel="noreferrer" target="_blank"><div className="social-icon-bilibili"></div></a>
              <a href="https://www.weibo.com/u/1926245291" rel="noreferrer" target="_blank"><div className="social-icon-weibo"></div></a>
              <a href="https://www.zhihu.com/org/kkmo-fa-xue-yuan" rel="noreferrer" target="_blank"> <div className="social-icon-zhihu"></div></a>
              {/* <a href="https://www.artstation.com/krenz" rel="noreferrer" target="_blank"><div className="social-icon-art"></div></a> */}

            </div>
          </div>
          <div className="text-box-introduce">
            <div><span>1985年生，元智大学信息传播学系毕业，现为Krenz's Artwork创办人及主讲师，目前在亚洲具有相当知名度。</span></div>
            <div><span>老师从2009年开始，研究动漫美术相关的2D绘图创作技巧，并陆续开设透视、动态、色彩等以美术基础为主的课程。因擅长解析，且用语、示范浅显易懂，逐渐在绘图教学界造成话题。</span></div>
            <div><span>2018年组织教学团队，展开网络课程，意透过教学将计算机绘图的技巧与观念交流传承给更多人，矢志带动绘图界人才的增长与水平。</span></div>
            <div><span>近12年的自由绘画经验，8年实体班教授CG绘画经验，不仅让老师在ARTSTATION影响力挤身 TOP 10，更于2015年取得了全站获赞数第一的成就。个人画册累计销售十数万册，且数次成为Schoolism、Animuc、The One Academy、厦门国际动漫节等海内外著名CG盛会的座上宾。</span></div>
          </div>
          <div className="teachingmiddleimg"></div>
        </div>

      </div>
      <div className="assistant-secondpart">
        <div style={{ height: 688, paddingTop: 70, minWidth: 1440 }}>
          <div className="more-work-title">
            <div className="en-more-work-title">MORE WORKS</div>
            <div className="cn-more-work-title">更多作品</div>
          </div>
          <MoreWorksPc change={change} setChange={setChange} />
        </div>
      </div>
      <div className="assistant-content">
        <div className="assistant-group">
          <div className="assistantgroup-title">
            <span>助教团队</span>
            <span>ASSISTANT TEAM</span>
          </div>
          <div className="assistgroup-avator" style={{ height: showmore === 1 ? 'auto' : showmore === 2 ? '244px' : '' }}>
            {
              atlist ? atlist.map(i => {
                return (
                  <div key={i.id} className="assistavator" onClick={() => { props.history.push(`/teache/${i.id}`, { i, atlist }) }}>{i.avatar ? <img width="100%" height="100%" src={i.avatar} alt="jiazaiz" /> : <div style={{ backgroundColor: '#efebe9', width: '100%', height: '100%' }}></div>}</div>
                )
              }) : ''
            }
          </div>
          {showmore === 2 ? <div className="clicklookmore" onClick={() => setShowMore(1)}>
            <div>MORE</div>
            <div></div>
          </div> : showmore === 1 ? <div className="clickupbtn" onClick={() => setShowMore(2)}><div>CLOSE</div><div></div></div> : null}
        </div>
      </div>
      <div className="assistant-collection">
        <div className="tomiddlecenter">
          <div className="assistant-collection-title">
            <span>助教作品</span>
            <span>ASSISTANT WORKS</span>
          </div>
          <div className="assistant-collection-content">
            <div className="assistant-collection-box">
              <div className="left-arrow1" onClick={() => { prev() }}></div>
              <div className="slidecollection" >
                <Carousel autoplay ref={collectbox} {...settings} >
                  {
                    arr.map((i, index) => (
                      <div className="slide-part" key={index}>
                        {
                          i ? i.map((j, index) => {
                            return (
                              <LazyLoad scrollContainer={'.home-content'} key={j.smallPicture} height={100} offset={500}>
                                <div className="single-img" key={j.url} onClick={(e) => {
                                  setCanvas(true)
                                  setCurrentUrl(j.id)
                                }}><img alt="jiazaiz" src={j.smallPicture} width="100%" height="100%" style={{ objectFit: 'cover' }} /></div>
                              </LazyLoad>
                            )
                          }) : ''
                        }
                      </div>
                    ))
                  }
                </Carousel>
              </div>
              <div className="right-arrow1" onClick={() => { next() }}></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function CollectionBigImg(props) {
  let { atcolist, currenturl } = props
  console.log(atcolist)
  const [page, setPage] = useState(atcolist.findIndex(i => i.id === currenturl))
  return (
    <div className="largecollect-box">

      <div className="middle-content-img">
        <div className="onclick-leftarrow" onClick={() => { setPage(state => state === 0 ? atcolist.length - 1 : state - 1) }}></div>
        <div className="slide-img-content">
          {
            atcolist.map((i, index) => {
              return (
                <div key={i.url} style={index === page ? { opacity: 1, transition: '1s all' } : { opacity: 0 }} ><img alt="jiazaiz" src={i.url} width="100%" height="100%" style={{ objectFit: "contain" }} /></div>
              )
            })
          }
        </div>
        <div className="onclick-rightarrow" onClick={() => { setPage(state => state >= atcolist.length - 1 ? 0 : state + 1) }}></div>
      </div>
      <div className="page-bottom-style" >{page + 1}/{atcolist.length}</div>

    </div>
  )
}

// let timer = null
// function MoreWorksPc(props){
//     const [index,setIndex] = useState(undefined)
//     const dataCurrent = useRef('')
//     let{change,setChange}= props
//     let setCanvas = useCanvas(useMemo(()=><RenderBigImg change={change} index={index} setChange={setChange}/>,[index,change,setChange]))
//     let oDiv = useRef()

//     useEffect(()=>{
//             if(!change.length)return;
//             let oBox = document.querySelector('.more-work-box')
//             let oUl = oBox.getElementsByTagName('ul')[0]
//             let oLi = oUl.getElementsByTagName('li');
//             dataCurrent.current = dataCurrent.current===''?oUl.innerHTML + oUl.innerHTML:dataCurrent.current
//             oUl.innerHTML = dataCurrent.current
//             let target = oLi[0].offsetWidth*oLi.length;
//             let ispeed = -Math.ceil(Math.random()*(target/2))+1;
//             function move(){
//              ispeed-=1;
//              if(ispeed<(-(target/2))){
//                  ispeed = 0;
//               }
//              oUl.style.transform = `translateX(${ispeed}px)`
//             }
//             const clearSpeed = ()=>{
//                 timer&&clearInterval(timer)
//             }
//             const openSpeed = ()=>{
//                 timer = setInterval(move,25)
//             }
//             clearSpeed()
//             openSpeed()
//             // oBox.addEventListener('mouseover',clearSpeed,false)
//             //  oBox.addEventListener('mouseout',openSpeed,)
//             oUl.onclick = function(e){
//                 if(e.target.parentNode.parentNode.tagName==='LI'){

//                     setCanvas(true)
//                     oBox.onmouseout=null
//                     setIndex(change.findIndex(j=>e.target.src.match(j.url)!==null))
//                 }
//              }

//              return ()=>{
//                 //  oBox.removeEventListener('mouseover',clearSpeed)
//                 //  oBox.removeEventListener('mouseout',openSpeed)
//                 clearInterval(timer)
//             }
//         }
//     ,[change,setCanvas])
//     return (
//             <div className='more-work-box' ref={oDiv}>
//                             <ul>
//                             {change && change.length>0? change.map(i=>{
//                               return(
//                                 <li  key={i.url} >
//                                      <div><img alt='jiazaiz' className="morework-img"  src={i.url} /></div>
//                                     <div className="description-style"><span >{i.description}</span></div>
//                                 </li>
//                                 )}):null}
//                             </ul>
//             </div>
//     )
// }



export default TeachingGroup